// Initialize current page
let pageNum = 1;

// Form selectors
const filterForm = document.querySelector('.filter__form');
const sortSelect = document.querySelector('[name="orderby"]');
const postList = document.querySelector('.post-list');
const visiblePosts = document.getElementById('visible-posts');
const totalPosts = document.getElementById('total-posts');

// Initialize request params
let queryString,
	data,
	formObj,
	params;

// Set form filters
function setFilters() {
	let params = (new URL(document.location)).searchParams;
	for (const [key, value] of params.entries()) {
		if (key === 'tags') {
			checkboxes = value.split(',');
			checkboxes.forEach(function(v) {
				document.querySelector('input[value='+v+']').checked = 'true';
			});
		} else {
			document.getElementsByName(key).forEach(p => p.value = value);
		}
	}
}
setFilters();

// Serialzie form data
function serialize(data) {
	let obj = {};
	for (let [key, value] of data) {
		if (obj[key] !== undefined) {
			if (!Array.isArray(obj[key])) {
				obj[key] = [obj[key]];
			}
			obj[key].push(value);
		} else {
			obj[key] = value;
		}
	}
	return obj;
}

function serializeData() {
	data = new FormData(filterForm);
	formObj = serialize(data);
	params = new URLSearchParams(formObj);
}

// Build query string
function makeQueryString() {
	serializeData();

	// Clean up queryString
	let keysForDel = [];
	params.forEach((v, k) => {
	  if (v === '' || v === undefined)
	    keysForDel.push(k);
	});
	keysForDel.forEach(k => {
	  params.delete(k);
	});

	queryString = params.toString();

	updateURL(queryString);
}

// Update URL with new params
function updateURL(params) {
	if (location.search) {
		history.pushState({}, null, location.href.replace(location.search, '?' + params));
	} else {
		history.pushState({}, null, location.href.replace(location.href, '?' + params));
	}
}

if (filterForm) {
	filterForm.addEventListener('change', function() {
	    makeQueryString();
	    filterPosts();
	});
}

function filterPosts() {
	serializeData();
	let request = new XMLHttpRequest();

    request.open('POST', '/wp-admin/admin-ajax.php', true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
    request.responseType = 'json';
    request.onload = function () {
    	let resp = this.response;
    	// Populate list
    	postList.innerHTML = resp.posts;
    	visiblePosts.innerText = resp.shown;
    	totalPosts.innerText = resp.total;
    };
    request.send('action=filter_posts&'+queryString);
}

// Pagination
document.addEventListener('click', function(e) {
   if (e.target.classList.contains('page-numbers')) {
   	e.preventDefault();
   	let href = e.srcElement.attributes.href.textContent;
	let pageNum = href.split('page/').pop().split('?')[0];
	document.querySelector('input[name="current-page"]').value = pageNum;
	makeQueryString();
	filterPosts();
   }
});

// Listen for back/forward
// window.addEventListener('popstate', function(e) {
// 	filterForm.reset();
// 	setFilters();
// 	filterPosts();
// }, true);